module.exports = __webpack_public_path__ + "static/media/bell.f8788fcc.svg";